const mapCategoryLevels = (categoryLevels) => {
    var _a, _b, _c, _d, _e, _f, _g;
    return ({
        product_category_level_1: (_b = (_a = categoryLevels === null || categoryLevels === void 0 ? void 0 : categoryLevels[0]) === null || _a === void 0 ? void 0 : _a.description) !== null && _b !== void 0 ? _b : '',
        product_category_level_2: (_d = (_c = categoryLevels === null || categoryLevels === void 0 ? void 0 : categoryLevels[1]) === null || _c === void 0 ? void 0 : _c.description) !== null && _d !== void 0 ? _d : '',
        product_category_level_3: (_f = (_e = categoryLevels === null || categoryLevels === void 0 ? void 0 : categoryLevels[2]) === null || _e === void 0 ? void 0 : _e.description) !== null && _f !== void 0 ? _f : '',
        product_category_path: (_g = categoryLevels === null || categoryLevels === void 0 ? void 0 : categoryLevels.map(l => l.description).filter(Boolean).join(', ')) !== null && _g !== void 0 ? _g : '',
    });
};
/**
 * Builds a view_category event payload. Category levels are resolved server-side
 * (see productLister handlers) in the fascia's analytics language.
 */
export const buildCategoryViewPayload = (categoryLevels, sourceId, searchQuery) => {
    var _a, _b, _c, _d, _e, _f, _g;
    return {
        category_1: (_b = (_a = categoryLevels === null || categoryLevels === void 0 ? void 0 : categoryLevels[0]) === null || _a === void 0 ? void 0 : _a.description) !== null && _b !== void 0 ? _b : '',
        category_2: (_d = (_c = categoryLevels === null || categoryLevels === void 0 ? void 0 : categoryLevels[1]) === null || _c === void 0 ? void 0 : _c.description) !== null && _d !== void 0 ? _d : '',
        category_3: (_f = (_e = categoryLevels === null || categoryLevels === void 0 ? void 0 : categoryLevels[2]) === null || _e === void 0 ? void 0 : _e.description) !== null && _f !== void 0 ? _f : '',
        category_name: (_g = categoryLevels === null || categoryLevels === void 0 ? void 0 : categoryLevels.map(l => l.description).filter(Boolean).join(', ')) !== null && _g !== void 0 ? _g : '',
        domain: window.location.hostname,
        // FHR/XO search response id — only Fredhopper's subscriber reads this; other
        // vendors ignore unrecognized fields on this vendor-agnostic payload.
        source_id: sourceId,
        // Search term, only present when this view is a search-results page rather than
        // a plain category/brand listing — also Fredhopper-specific (metadata.query).
        search_query: searchQuery,
    };
};
const getSelectedColor = (product) => { var _a; return (_a = product.productColorVariations) === null || _a === void 0 ? void 0 : _a.find(color => color.colorId === product.selectedColorId); };
const getSelectedSize = (selectedColor, selectedSku) => {
    var _a;
    if (!selectedColor || !selectedSku) {
        return undefined;
    }
    return (_a = selectedColor.sizes) === null || _a === void 0 ? void 0 : _a.find(size => size.sku === selectedSku);
};
/**
 * Resolves a representative SKU that is always present, even before the user
 * picks a size. Falls back: selected sku → selected colour's first size →
 * first colour's first size.
 */
const getDefaultSku = (product, selectedColor) => { var _a, _b, _c, _d, _e, _f, _g, _h, _j; return (_j = (_d = (_a = product.selectedSku) !== null && _a !== void 0 ? _a : (_c = (_b = selectedColor === null || selectedColor === void 0 ? void 0 : selectedColor.sizes) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.sku) !== null && _d !== void 0 ? _d : (_h = (_g = (_f = (_e = product.productColorVariations) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.sizes) === null || _g === void 0 ? void 0 : _g[0]) === null || _h === void 0 ? void 0 : _h.sku) !== null && _j !== void 0 ? _j : ''; };
/**
 * Builds a product_click event payload — a click on a product tile, whether in the
 * lister, a campaign tile, or a recommendation/comparison widget.
 */
export const buildProductClickPayload = (productId, options) => ({
    product_id: productId,
    source_id: options === null || options === void 0 ? void 0 : options.sourceId,
    campaign_id: options === null || options === void 0 ? void 0 : options.campaignId,
});
/**
 * Builds an additional_product_cart_add event payload for a single product added
 * via the PDP "additional products" (cross-sell) flow — main product or accessory.
 */
export const buildAdditionalProductCartAddPayload = (productId, sku, quantity) => ({
    product_id: productId,
    sku_id: sku,
    quantity,
});
/**
 * Builds a facet_click event payload — a click on a filter/facet value.
 */
export const buildFacetClickPayload = (facetId, facetValue, sourceId) => ({
    facet_id: facetId,
    facet_value: facetValue,
    source_id: sourceId,
});
/**
 * Builds a purchase event payload for a single product line of a completed order.
 * Emit once per distinct product — group multiple products under the same orderId.
 */
export const buildPurchasePayload = (productId, orderId, price, quantity, currency) => ({
    product_id: productId,
    order_id: orderId,
    price,
    quantity,
    currency,
});
/**
 * Builds a view_item event payload from a ProductDetail.
 */
export const buildViewItemPayload = (product, categoryLevels) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    const selectedColor = getSelectedColor(product);
    const selectedSize = getSelectedSize(selectedColor, product.selectedSku);
    return Object.assign(Object.assign({ product_id: product.productId, sku_id: (_a = product.selectedSku) !== null && _a !== void 0 ? _a : '', default_sku: getDefaultSku(product, selectedColor), buying_group: (_b = product.buyingGroup) !== null && _b !== void 0 ? _b : '' }, mapCategoryLevels(categoryLevels)), { price: (_d = (_c = selectedColor === null || selectedColor === void 0 ? void 0 : selectedColor.prices) === null || _c === void 0 ? void 0 : _c.SELL) === null || _d === void 0 ? void 0 : _d.original, brand: (_f = (_e = product.brand) === null || _e === void 0 ? void 0 : _e.description) !== null && _f !== void 0 ? _f : '', title: (_h = (_g = product.productTranslatedProperties) === null || _g === void 0 ? void 0 : _g.title) !== null && _h !== void 0 ? _h : '', colour: (_j = selectedColor === null || selectedColor === void 0 ? void 0 : selectedColor.color) !== null && _j !== void 0 ? _j : '', colour_code: (_k = selectedColor === null || selectedColor === void 0 ? void 0 : selectedColor.colorCode) !== null && _k !== void 0 ? _k : '', size: (_l = selectedSize === null || selectedSize === void 0 ? void 0 : selectedSize.fullCommercialSize) !== null && _l !== void 0 ? _l : '', gender: (_m = product.gender) !== null && _m !== void 0 ? _m : '', stock: (_o = product.productAvailability) !== null && _o !== void 0 ? _o : 0 });
};
/**
 * Builds a cart_update event payload.
 */
export const buildCartUpdatePayload = (action, product, basketProducts = [], totalQuantity, pricing, sourceId) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    return {
        action,
        product_id: product.productId,
        sku_id: String((_a = product.sku) !== null && _a !== void 0 ? _a : ''),
        quantity: product.quantity,
        is_full_removal: (_b = product.isFullRemoval) !== null && _b !== void 0 ? _b : true,
        product_list: basketProducts.map(p => {
            var _a, _b, _c;
            return ({
                product_id: p.productId,
                sku_id: p.sku,
                price: (_c = (_b = (_a = p.prices) === null || _a === void 0 ? void 0 : _a.SELL) === null || _b === void 0 ? void 0 : _b.original) !== null && _c !== void 0 ? _c : p.price,
                quantity: p.quantity,
                brand: p.brand,
            });
        }),
        product_ids: basketProducts.map(p => p.productId),
        buying_group: (_c = product.buyingGroup) !== null && _c !== void 0 ? _c : '',
        price: product.price,
        total_price: pricing.priceTotalBasket,
        total_quantity: totalQuantity,
        title: (_d = product.title) !== null && _d !== void 0 ? _d : '',
        brand: (_e = product.brand) !== null && _e !== void 0 ? _e : '',
        colour: (_f = product.colour) !== null && _f !== void 0 ? _f : '',
        colour_code: (_g = product.colourCode) !== null && _g !== void 0 ? _g : '',
        gender: (_h = product.gender) !== null && _h !== void 0 ? _h : '',
        size: (_j = product.size) !== null && _j !== void 0 ? _j : '',
        // FHR/XO search or recommendation response id — only Fredhopper's subscriber
        // reads this; other vendors ignore unrecognized fields on this payload.
        source_id: sourceId,
    };
};
